/**
 * Created by Josef Jurca on 24/04/17.
 */
import {ReminderStatus, ActionTypes} from 'store/actions/modals/setreminder';

/**
 * Status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function status (state = ReminderStatus.INITIAL, action) {

    switch (action.type) {

        case ActionTypes.SET_REMINDER_STATUS:
            return action.status;

        default:
            return state;
    }
}

/**
 * Form data logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function data (state = {
                   setReminderHandler: () => {},
                   cancelHandler: () => {}
               }, action) {

    switch (action.type) {

        case ActionTypes.SET_REMINDER_DATA:
            return {
                ...action
            };

        default:
            return state;
    }
}

/**
 * Error logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function error (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_REMINDER_ERROR:
            return action.error || '';

        default:
            return state;
    }
}

/**
 * Confirm reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Confirm reducer.
 */
export default function setReminder (state = {}, action) {

    return {
        status: status(state.status, action),
        data: data(state.data, action),
        error: error(state.error, action)
    };
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/modals/setreminder.js